import { addons } from '@storybook/addons';
import eyTheme from './ey-theme';

addons.setConfig({
  theme: eyTheme,
});
